import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-499c04e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FTLOrderStockDeliveryNote" }
const _hoisted_2 = { class: "FTLOrderStockDeliveryNote__content" }
const _hoisted_3 = { class: "content__field" }
const _hoisted_4 = { class: "field__placeholder" }
const _hoisted_5 = { class: "field__value" }
const _hoisted_6 = { class: "content__field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Номер ТТН", -1))
const _hoisted_8 = { class: "field__value" }
const _hoisted_9 = { class: "content__field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Контактное лицо", -1))
const _hoisted_11 = { class: "field__value" }
const _hoisted_12 = { class: "content__field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Адрес получателя", -1))
const _hoisted_14 = { class: "field__value" }
const _hoisted_15 = { class: "content__field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Наименование получателя", -1))
const _hoisted_17 = { class: "field__value" }
const _hoisted_18 = { class: "content__field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Номер получателя", -1))
const _hoisted_20 = { class: "field__value" }
const _hoisted_21 = { class: "FTLOrderStockDeliveryNote__actions" }
const _hoisted_22 = ["href", "download"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download mr-2" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload mr-2" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print mr-2" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ftl_additional_service = _resolveComponent("ftl-additional-service")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.stockDeliveryNote.receiver.is_endpoint)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" Конечный пункт ")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" Промежуточный пункт ")
              ], 64))
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.stockDeliveryNote.receiver.is_endpoint)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" Да ")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.stockDeliveryNote.receiver.number), 1)
              ], 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.stockDeliveryNote.number || '-') + " (" + _toDisplayString(_ctx.stockDeliveryNote.directionName || '-') + ") ", 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.stockDeliveryNote.receiver.full_name || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.stockDeliveryNote.receiver.address || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.stockDeliveryNote.receiver.title || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          (_ctx.stockDeliveryNote.receiver.additional_phone)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.stockDeliveryNote.receiver.phone) + ", " + _toDisplayString(_ctx.stockDeliveryNote.receiver.additional_phone), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.stockDeliveryNote.receiver.phone || '-'), 1)
              ], 64))
        ])
      ])
    ]),
    (_ctx.stockDeliveryNote.additional_service && _ctx.stockDeliveryNote.additional_service.length)
      ? (_openBlock(), _createBlock(_component_ftl_additional_service, {
          key: 0,
          class: "mt-3",
          short: "",
          "additional-service": _ctx.stockDeliveryNote.additional_service
        }, null, 8, ["additional-service"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_21, [
      (Boolean(_ctx.stockDeliveryNote.scan))
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: _ctx.stockDeliveryNote.scan,
            download: _ctx.stockDeliveryNote.scan,
            target: "_blank"
          }, [
            _createVNode(_component_the_button, { class: "primary small" }, {
              default: _withCtx(() => [
                _hoisted_23,
                _createTextVNode(" Скачать скан ")
              ]),
              _: 1
            })
          ], 8, _hoisted_22))
        : (_openBlock(), _createBlock(_component_the_button, {
            key: 1,
            class: "primary small",
            loading: _ctx.isUploadingScan,
            disabled: _ctx.isUploadingScan,
            onClick: _ctx.uploadScan
          }, {
            default: _withCtx(() => [
              _hoisted_24,
              _createTextVNode(" Загрузить скан ")
            ]),
            _: 1
          }, 8, ["loading", "disabled", "onClick"])),
      _createVNode(_component_the_button, {
        class: "primary small",
        loading: _ctx.isPrintingInvoice,
        disabled: _ctx.isPrintingInvoice,
        onClick: _ctx.printInvoice
      }, {
        default: _withCtx(() => [
          _hoisted_25,
          _createTextVNode(" Распечатать накладную ")
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"]),
      _createVNode(_component_router_link, {
        target: "_blank",
        to: `/ttn/${_ctx.stockDeliveryNote.id}/print/${_ctx.$route.params.order_id}`
      }, {
        default: _withCtx(() => [
          _createVNode(_component_the_button, { class: "primary small" }, {
            default: _withCtx(() => [
              _hoisted_26,
              _createTextVNode(" Распечатать ТТН ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}